var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":75,"indeterminate":""}}):_c('span',[_c('strong',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.message))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }